module.exports = (__webpack_require__("49fU"))(273);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/redux-persist/es/index.js from dll-reference vendor_library
// module id = AyKp
// module chunks = 24